'use strict'

import $ from 'jquery'
import enquire from 'enquire.js'
import archiveGrid from './archive-grid'
import archiveDetail from './archive-detail'
import fooTv from './foo-tv'
import headerMobile from './header-mobile'
import headerDesktop from './header-desktop'
import navMobile from './nav-mobile'
import navDesktop from './nav-desktop'
import cartMobile from './cart-mobile'
import cartDesktop from './cart-desktop'
import loader from './loader'
import * as myfoo from './myfoo'
import productGrid from './product-grid'
import productSelect from './product-select'
import {productSlider, stickyContent} from './product-detail'
import screensaver from './screensaver'
import shareButton from './share-button'
import sizingGuide from './sizing-guide'
import slider from './slider'
import subscribeMini from './subscribe-mini'
import videoPlayer from './video-player'
import uaDetect from './ua-detect'

const DESKTOP_BREAKPOINT = '58em'
const Shopify = window.Shopify
const sessionStorage = window.sessionStorage

$(function () {
  const $rootEl = $('html')
  const $bodyEl = $('body')

  console.log(`\n%c###%c▓▓▓███▓▓▓%c_\n###%cFO▓%c▓ND%cF▓O%c_\n###%c███▓▓▓███%c_%c\n${Date.now()}\n`,
    'background: #000; color: #333',
    'background: #333; color: #000',
    'background: #000; color: #333',
    'background: #000; color: yellow',
    'background: yellow; color: #000',
    'background: #000; color: yellow',
    'background: #000; color: #333',
    'background: #000; color: #333',
    'background: #000; color: #000;',
    'background: #000; color: #666;'
  )

  // Site-wide modules
  // =========================
  if (sessionStorage.getItem('loader-has-loaded') !== 'true') {
    loader.init()
  }

  const { isSafari, isFirefox, isIpad, isIphone } = uaDetect

  if (isSafari) {
    $rootEl.addClass('safari')
  } else if (isFirefox) {
    $rootEl.addClass('firefox')
  }

  if (isIpad) {
    $rootEl.addClass('is-ipad')
  } else if (isIphone) {
    $rootEl.addClass('is-iphone')
  }

  videoPlayer()

  // INITIALIZE VIEWPORT-SIZE-DEPENDENT SCRIPTS ("DESKTOP" MATCHED)
  enquire.register(`screen and (min-width: ${DESKTOP_BREAKPOINT})`, {
    match: () => {
      headerDesktop()
      navDesktop()
      cartDesktop()

      $(window).on('load', function() {
        if (!isIpad) {
          screensaver.startListener()
        }
      })
    },
    unmatch: () => {
      location.reload()
    },
    deferSetup: true,
  })

  // INITIALIZE VIEWPORT-SIZE-DEPENDENT SCRIPTS ("MOBILE" MATCHED)
  enquire.register(`screen and (max-width: ${DESKTOP_BREAKPOINT})`, {
    match: () => {
      headerMobile()
      navMobile()
      cartMobile()
    },
    unmatch: () => {
      location.reload()
    },
    deferSetup: true,
  })

  // Location-specific modules
  // =========================
  if (checkIsTemplate('index')) {
    fooTv('#FooTvIndex')
    shareButton()
    slider()
    subscribeMini()
  }

  if (checkIsTemplate('collection')) {
    shareButton()
    productGrid()
  }

  if (checkIsTemplate('search')) {
    productGrid()
  }

  if (checkIsTemplate('blog')) {
    archiveGrid()
  }

  if (checkIsTemplate('article')) {
    shareButton('[data-share]', true)
    archiveDetail()
  }

  if (checkIsTemplate('product')) {
    fooTv('#FooTvProduct')
    sizingGuide()
    productSlider()

    enquire.register(`screen and (min-width: ${DESKTOP_BREAKPOINT})`, {
      match: () => {
        stickyContent()
      }
    })

    new Shopify.OptionSelectors('ProductSelect', {
      product: window.FOOFOO.product,
      onVariantSelected: productSelect,
      enableHistoryState: true,
    })
  }

  if (checkIsAccountPage('account')) {
    myfoo.splitAccountAndOrders()
  }

  if (checkIsAccountPage('order')) {
    $('.nav-info__link')
      .removeClass('is-active')
      .filter('.nav-info__link--orders')
      .addClass('is-active')
  }

  if (checkIsAccountPage('addresses')) {
    $('.checkbox-pseudo').on('click', function() {
      $(this).siblings('.checkbox-wrap').find('input[type=checkbox]').trigger('click')
    })
  }

  if (checkIsAccountPage('login')) {
    myfoo.loginControls()
  }

  if (checkIsAccountPage('register')) {
    myfoo.registerControls()
  }

  function checkIsTemplate(handle = '') {
    return $bodyEl.hasClass('template-' + handle)
  }

  function checkIsAccountPage(handle = '') {
    return $bodyEl.hasClass('template-customers/' + handle)
  }
})



// WEBPACK FOOTER //
// ./main.js